import React, { useState } from "react";

import { IconButton, InputAdornment, TextField } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export const PasswordText = ({
  value,
  onChange,
  label = "Senha",
  error = false,
  withConfirmation = false,
  disabled = false,
}: PasswordTextProps) => {
  const [hidePassword, setHidePassword] = useState(true);
  const [hidePasswordConfirmation, setHidePasswordConfirmation] =
    useState(true);
  const [confirmationValue, setConfirmationValue] = useState("");

  const PasswordIcon = ({ hide, onClick }) => (
    <InputAdornment position="end">
      <IconButton onClick={onClick} disabled={disabled}>
        {hide ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    </InputAdornment>
  );

  const toggleVisibility = () => {
    setHidePassword((prev) => !prev);
  };

  const togglePasswordConfirmationVisibility = () => {
    setHidePasswordConfirmation((prev) => !prev);
  };

  const confirmationError =
    withConfirmation &&
    confirmationValue.length > 0 &&
    value.length > 0 &&
    value !== confirmationValue;

  return (
    <>
      <TextField
        required
        fullWidth
        variant="outlined"
        label={label}
        InputProps={{
          endAdornment: (
            <PasswordIcon hide={hidePassword} onClick={toggleVisibility} />
          ),
        }}
        type={hidePassword ? "password" : "text"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        disabled={disabled}
      />
      {withConfirmation && (
        <TextField
          required
          fullWidth
          variant="outlined"
          label="Repita sua senha"
          InputProps={{
            endAdornment: (
              <PasswordIcon
                hide={hidePasswordConfirmation}
                onClick={togglePasswordConfirmationVisibility}
              />
            ),
          }}
          type={hidePasswordConfirmation ? "password" : "text"}
          value={confirmationValue}
          onChange={(e) => setConfirmationValue(e.target.value)}
          error={confirmationError}
        />
      )}
    </>
  );
};

export type PasswordTextProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  error?: boolean;
  withConfirmation?: boolean;
  disabled?: boolean;
};
